export default __webpack_public_path__ + "media/images/paylogos/gray/maestro-394e4a05b2ada65440a063376fcb3f2e.png";